const css = `.coupon-display {
  display: flex;
  align-items: center;
  column-gap: 8px;
}
.coupon-display .p-tag {
  white-space: nowrap;
}
.coupon-display.loading {
  margin: 12px;
}
.coupon-display .coupon-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.coupon-display small {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.coupon-display small.warning {
  color: var(--warning) !important;
  font-weight: var(--font-weight-bold);
}
.coupon-display small.error {
  color: var(--danger) !important;
  font-weight: var(--font-weight-bold);
}
.coupon-display small.shared-users {
  color: var(--text-color-secondary);
  font-size: var(--font-size-xs);
  font-style: italic;
  display: flex;
  align-items: center;
  gap: 4px;
}
.coupon-display small.shared-users .pi-users {
  font-size: var(--font-size-2xs);
  opacity: 0.7;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL2NvbXBvbmVudHMvQ291cG9uRGlzcGxheSIsInNvdXJjZXMiOlsiQ291cG9uRGlzcGxheS5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBQ0U7O0FBR0Y7RUFDRTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUdGO0VBQ0U7RUFDQTtFQUNBOztBQUVBO0VBQ0U7RUFDQTs7QUFFRjtFQUNFO0VBQ0E7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiLmNvdXBvbi1kaXNwbGF5IHtcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgY29sdW1uLWdhcDogOHB4O1xuXG4gIC5wLXRhZyB7XG4gICAgd2hpdGUtc3BhY2U6IG5vd3JhcDtcbiAgfVxuXG4gICYubG9hZGluZyB7XG4gICAgbWFyZ2luOiAxMnB4O1xuICB9XG5cbiAgLmNvdXBvbi1pbmZvIHtcbiAgICBkaXNwbGF5OiBmbGV4O1xuICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgZ2FwOiAycHg7XG4gICAgbWluLXdpZHRoOiAwOyAvLyBQZXJtaXRlIHF1ZSBlbCBjb250ZW5pZG8gc2UgY29udHJhaWdhXG4gIH1cblxuICBzbWFsbCB7XG4gICAgd2hpdGUtc3BhY2U6IG5vd3JhcDtcbiAgICBvdmVyZmxvdzogaGlkZGVuO1xuICAgIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzO1xuXG4gICAgJi53YXJuaW5nIHtcbiAgICAgIGNvbG9yOiB2YXIoLS13YXJuaW5nKSAhaW1wb3J0YW50O1xuICAgICAgZm9udC13ZWlnaHQ6IHZhcigtLWZvbnQtd2VpZ2h0LWJvbGQpO1xuICAgIH1cbiAgICAmLmVycm9yIHtcbiAgICAgIGNvbG9yOiB2YXIoLS1kYW5nZXIpICFpbXBvcnRhbnQ7XG4gICAgICBmb250LXdlaWdodDogdmFyKC0tZm9udC13ZWlnaHQtYm9sZCk7XG4gICAgfVxuXG4gICAgJi5zaGFyZWQtdXNlcnMge1xuICAgICAgY29sb3I6IHZhcigtLXRleHQtY29sb3Itc2Vjb25kYXJ5KTtcbiAgICAgIGZvbnQtc2l6ZTogdmFyKC0tZm9udC1zaXplLXhzKTtcbiAgICAgIGZvbnQtc3R5bGU6IGl0YWxpYztcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgZ2FwOiA0cHg7XG5cbiAgICAgIC5waS11c2VycyB7XG4gICAgICAgIGZvbnQtc2l6ZTogdmFyKC0tZm9udC1zaXplLTJ4cyk7XG4gICAgICAgIG9wYWNpdHk6IDAuNztcbiAgICAgIH1cbiAgICB9XG4gIH1cbn1cbiJdfQ== */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
